<template>
  <div id="q-app">
    <LoadingIndicator />

    <transition
      enter-active-class="animated fadeIn"
      leave-active-class="animated fadeOut"
      appear
      :duration="300"
    >
      <router-view v-if="!isBooting" />
    </transition>
  </div>
</template>
<script>
import errorDialog from 'src/mixins/errorDialog';
import {
  mapActions, mapGetters, mapMutations, mapState,
} from 'vuex';
import LoadingIndicator from 'components/ui/LoadingIndicator';

export default {
  name: 'App',
  components: { LoadingIndicator },
  mixins: [errorDialog],

  computed: {
    ...mapState('application', ['isBooting']),
    ...mapGetters('account', ['isAuthenticated']),
  },

  async mounted() {
    try {
      // Check if user should be logged in
      await this.loadCredentials();
      if (!this.isAuthenticated) {
        this.$router.replace({ name: 'UserAuthentication' }).catch();
        await this.getAllLocations();
        await this.getAll();
      }
      else {
        // We have a user so we boot
        try {
          await this.boot();
        }
        catch (e) {
          // Boot failed. We need to clear everything and reauthenticate.
          if (e.status === 403) {
            await this.logout();
          }
        }
      }
    }
    catch (e) {
      // todo: Initializing failed
      // this.$router.replace({ name: 'error-boot' }).catch();
    }
    finally {
      this.bootComplete();
    }
  },

  methods: {
    ...mapActions('account', ['loadCredentials', 'logout']),
    ...mapActions('application', ['boot', 'getAllLocations']),
    ...mapActions('airQuality', ['getAll']),
    ...mapMutations('application', ['bootComplete']),
  },
};
</script>
